// extracted by mini-css-extract-plugin
module.exports = {"content":"TextRotator_content__3-edf","active":"TextRotator_active__2y5qg"};